import React, { FunctionComponent } from "react";
import styles from "./CustomInput.module.css";

type CustomInputProps = {
  type?: "text" | "number" | "tel" | "email" | "password"; // Add more types as needed
  prefix?: string; // For phone number or other prefixes
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
};

const CustomInput: FunctionComponent<CustomInputProps> = ({
  type = "text",
  prefix,
  placeholder,
  value,
  onChange,
}) => {
  return (
    <div
      className={styles.customInputContainer}
    >
      {prefix && (
        <span
          style={{
            marginRight: "0.5rem",
            color: "#303030",
            fontSize: "0.9rem",
          }}
        >
          {prefix}
        </span>
      )}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          flex: 1,
          border: "none",
          outline: "none",
          fontSize: "0.9rem",
        }}
      />
    </div>
  );
};

export default CustomInput;
